import { UserDocument } from '../lib/userDocuments.slice'
import { toLocalFullDate } from '../lib/helpers'
import { Table } from '@/ui'

interface DateUploadedCellProps {
  document: UserDocument
}

export const DateUploadedCell = ({ document }: DateUploadedCellProps) => (
  <Table.Cell>
    {/* Required, missing documents have their id set to -1 */}
    {document.id !== -1 && toLocalFullDate(document.createdAt)}
  </Table.Cell>
)
